'use client'

import React from 'react'
import type { ContentBlock as ContentBlockProps } from '@/payload-types'
import { Section } from '@/components/Section'
import RichText from '@/components/RichText'

export function ContentClient(props: ContentBlockProps) {
  const { content } = props

  return (
    <Section bgClassName="bg-paper-1">
      {content && <RichText className="prose-info max-w-readable-lg" data={content} />}
    </Section>
  )
}
